import { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";
import { Store } from "./Store";

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { state } = useContext(Store);
  const { userInfo } = state;

  useEffect(() => {
    if (userInfo && userInfo.restaurantId) {
      // Initialize socket connection using the same base URL as axios
      const newSocket = io(
        window.location.hostname === "localhost"
          ? "http://localhost:8000"
          : window.location.origin
      );

      setSocket(newSocket);

      // Join the specific restaurant room
      newSocket.emit("join_restaurant", userInfo.restaurantId);

      // Cleanup on unmount or user change
      return () => newSocket.close();
    } else {
      if (socket) {
        socket.close();
        setSocket(null);
      }
    }
  }, [userInfo]); // Re-run if userInfo changes (login/logout)

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};
